import React from "react";
import HeaderTabs from "../../HeaderBar/containers/HeaderTabs/HeaderTabs";

export const Navigation: React.FC<any> = (props) => {
    if (window.location.pathname.includes("/buddies/intro")) return null;
    return <HeaderTabs primaryApp={props.primaryApp} {...props} />;
};
